"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../index");
var withBreadcrumbHOC = function (Component) {
    return function (props) { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "oui-margin-medium-bottom" },
            React.createElement(index_1.Breadcrumb, { items: props.breadcrumbItems })),
        React.createElement(Component, __assign({}, props)))); };
};
exports.default = withBreadcrumbHOC;
//# sourceMappingURL=withBreadcrumbHOC.js.map